import '@fontsource/Quicksand/300.css'
import '@fontsource/Quicksand/400.css'
import '@fontsource/Quicksand/500.css'
import '@fontsource/Quicksand/700.css'
import './src/styles/global.css'
import Layout from './src/components/layout'
import React from 'react'
import AuthContext from './src/components/contexts/auth'
import ThemeModeContext from './src/components/contexts/themeMode'
import NeighbourContext from './src/components/contexts/neighbour'
import { Location } from '@reach/router'
import DataContext from './src/components/contexts/data'

export const wrapRootElement = ({ element }) => (
    <Location>
        {(location) => (
            <AuthContext {...location}>
                <NeighbourContext {...location}>
                    <DataContext>
                        <ThemeModeContext>{element}</ThemeModeContext>
                    </DataContext>
                </NeighbourContext>
            </AuthContext>
        )}
    </Location>
)

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
    return <Layout {...props}>{element}</Layout>
}
